export enum SendSerajEventErrors {
  InternalError = 50,
}

export const SendSerajEventErrorMessages = {
  [SendSerajEventErrors.InternalError]: "InternalError",
};
